import { useTranslation } from "react-i18next";
import ZeitonSetupOrganization from "../../Images/ZeitonSetupOrganization.png";
import ZeitonBuildYourNetwork from "../../Images/ZeitonBuildYourNetwork.png";
import ZeitonResourcePlanning from "../../Images/ZeitonResourcePlanning.png";
import ZeitonApplicantTracking from "../../Images/ZeitonApplicantTracking.png";
import DetailedFeatureItem from "./DetailedFeatureItem";

export default function ZeitonFeaturesDetailed() {
    const { t } = useTranslation();

    const items = [
        {
            image: ZeitonSetupOrganization,
            title: t("SetupOrganization"),
            text: t("SetupDescription"),
            backgroundClass: "xl:bg-detailedFeaturesGlassOne xl:bg-cover xl:bg-center xl:bg-no-repeat rounded-[20px]"
        },
        {
            image: ZeitonBuildYourNetwork,
            title: t("BuildYourNetwork"),
            text: t("NetworkDescription"),
            backgroundClass: "bg-[#FF61041A] xl:bg-#F6F6F6"
        },
        {
            image: ZeitonResourcePlanning,
            title: t("ResourcePlanningProjectTracking"),
            text: t("ResourceDescription"),
            backgroundClass: "xl:bg-detailedFeaturesGlassTwo xl:bg-cover xl:bg-center xl:bg-no-repeat rounded-[20px]"
        },
        {
            image: ZeitonApplicantTracking,
            title: t("ApplicantTrackingHiring"),
            text: t("ApplicantTrackingDescription"),
            backgroundClass: "bg-[#FF61041A] xl:bg-#F6F6F6"
        },
    ];

    return (
        <div className="flex flex-col bg-#F6F6F6 px-[30px] lg:px-[100px]">
            <h2 className="text-lg xl:text-2xl uppercase font-bold p-[30px] xl:p-[60px] text-center">{t("ZeitonDetailedFeaturesTitle")}</h2>
            {items.map((item, index) => (
                <DetailedFeatureItem
                    key={index}
                    image={item.image}
                    title={item.title}
                    text={item.text}
                    backgroundClass={item.backgroundClass}
                    index={index} />
            ))}
        </div>
    )
}